import { Component, OnInit, Inject, ApplicationRef } from '@angular/core';
import { NavigationStart, Router, NavigationEnd } from '@angular/router';
import { PerfilService } from 'src/app/services/perfil.service';
import { environment } from 'src/environments/environment';
import { GeneralService } from './services/general.service';
import { DataService } from './shared/services/data.service';
import { PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { filter, take } from 'rxjs/operators';
import { EventReplayer } from 'preboot';

//declare let gtag: Function;
//declare let UAC: Function;
//Se agrega función facebook para pixel
declare let fbq: Function; 

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],

})
export class AppComponent implements OnInit {

  constructor(
    private router: Router,
    private dataService: DataService,
    private generalService: GeneralService,
    private perfilService: PerfilService,
    @Inject(PLATFORM_ID) public platformId: Object,
    private appRef: ApplicationRef,
    private replayer: EventReplayer
  ) { }

  ngOnInit() {

/*
    if (isPlatformBrowser(this.platformId)) {
      this.appRef.isStable
        .pipe(
          filter(stable => stable),
          take(1),
        ).subscribe(() => {
          setTimeout(()=> {
            this.replayer.replayAll();
          },8000);
      });
    }*/

    if (isPlatformBrowser(this.platformId)) {
      navigator.geolocation.getCurrentPosition(
        position => this.geolocationSuccess(position),
        error => this.onErrorGeo(error)
      );

      this.router.events.subscribe(event => {
        if (event instanceof NavigationEnd) {
          
          /*
          gtag('config', UAC(),
            {
              'page_path': event.urlAfterRedirects
            }
          );
          */
            
          //Pixel de facebook
          fbq('track', 'PageView');
        }
      })
      
    }


    this.router.events.subscribe(e => {
      if (e instanceof NavigationStart) {
        this.dataService.changeUrl(e.url);
      }
    });
  }





  onErrorGeo(error) {
    console.log('code: ' + error.code + '\n' +
      'message: ' + error.message + '\n');
  }

  geolocationSuccess(position) {
    console.log(`Latitude: ${position.coords.latitude} 
      Longitude: ${position.coords.longitude}`);
    this.perfilService.saveLocalizacion(position.coords.latitude, position.coords.longitude);
  }
}
